// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';
import {describeApiOutcome} from '@/utils/apiOutcome';

const CUSTOMER_ORGANIZATIONS_UNAVAILABLE = 'Organisaties konden niet worden geladen.';

const actions = {
    findByCustomerId: async ({dispatch}, payload) => {
        const outcome = describeApiOutcome(await dispatch('getAll', payload), {
            fallback: CUSTOMER_ORGANIZATIONS_UNAVAILABLE,
        });

        if (!outcome.ok || !outcome.data || !Array.isArray(outcome.data.data)) {
            return {ok: false, organization: null, message: outcome.message || CUSTOMER_ORGANIZATIONS_UNAVAILABLE};
        }

        const customerId = String(payload.customerId || '');
        const organization = outcome.data.data
            .find(candidate => String(candidate.firebaseId) === customerId) || null;

        return {ok: true, organization, message: null};
    },
    renameByCustomerId: async ({dispatch}, payload) => {
        const found = await dispatch('findByCustomerId', payload);

        if (!found.ok || !found.organization || found.organization.name.trim() === payload.name.trim()) {
            return {ok: found.ok, message: found.message};
        }

        const outcome = describeApiOutcome(await axios.patch(
            process.env.VUE_APP_HOUR_APP_BACKEND + '/api/organization/' + found.organization.id,
            {name: payload.name},
            {params: {firebaseIdToken: payload.ApiClient.token}},
        ).catch(err => err), {field: 'name'});

        return {ok: outcome.ok, message: outcome.message};
    },
    getAll: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/organizations', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    get: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const company_id = payload.company_id;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/organization/' + company_id, {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    getConfig: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const company_id = payload.company_id;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/organization/' + company_id + '/config', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
    updateConfig: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;
        const company_id = payload.company_id;
        const config = payload.config;

        return axios.patch(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/organization/' + company_id + '/config', 
            {
                approved_by: config.approved_by,
                approved_policy: config.approved_policy
            },
            {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            return res
          }).catch((err) => {
            return err
        });
    },
}

export default actions
